import * as dayjs from 'dayjs';

const titleOptions = [
    'registration.prof',
    'registration.dr',
    'registration.mr',
    'registration.ms',
    'registration.mrs'
];

const telOptions = ["+852","+853","+86","+886","+65","+81","+66","+1","+7","+20","+27","+30","+31","+32","+33","+34","+36","+39","+40","+41","+43","+44","+45","+46","+47","+48","+49","+51","+52","+53","+54","+55","+56","+57","+58","+60","+61","+62","+63","+64","+82","+84","+90","+91","+92","+93","+94","+95","+98","+211","+212","+213","+216","+218","+220","+221","+222","+223","+224","+225","+226","+227","+228","+229","+230","+231","+232","+233","+234","+235","+236","+237","+238","+239","+240","+241","+242","+243","+244","+245","+246","+248","+249","+250","+251","+252","+253","+254","+255","+256","+257","+258","+260","+261","+262","+263","+264","+265","+266","+267","+268","+269","+290","+291","+297","+298","+299","+350","+351","+352","+353","+354","+355","+356","+357","+358","+359","+370","+371","+372","+373","+374","+375","+376","+377","+378","+379","+380","+381","+382","+385","+386","+387","+389","+420","+421","+423","+500","+501","+502","+503","+504","+505","+506","+507","+508","+509","+590","+591","+592","+593","+594","+595","+596","+597","+598","+599","+670","+672","+673","+674","+675","+676","+677","+678","+679","+680","+681","+682","+683","+685","+686","+687","+688","+689","+690","+691","+692","+850","+855","+856","+870","+880","+960","+961","+962","+963","+964","+965","+966","+967","+968","+970","+971","+972","+973","+974","+975","+976","+977","+992","+993","+994","+995","+996","+998"];

const fansForm = [
    // 教育机构
    { id: 'institution_name', group:1, isRequest: true, label: 'registration.institution_name', type: 'input' },
    // 年级
    { id: 'year_grade', group:1, isRequest: true, label: 'registration.year_grade', type: 'input' },
    // 学生证明
    { id: 'student_card_images', group:1, isRequest: true, label: 'registration.student_card_images', type: 'upload', desc: 'registration.edu-file-desc', fileTitle: 'registration.student_file_title' },
    // 预计毕业时间
    { id: 'expected_grad_date', group:1, isRequest: true, label: 'registration.expected_grad_date', type: 'date', format: 'DD/MM/YYYY', views: ['day', 'month', 'year'], min: dayjs(), max: null }
];

const associationForm = [
    // 公司名称
    { id: 'organisation_name', group:1, isRequest: true, label: 'registration.organisation_name', type: 'input' },
    // 职位
    { id: 'position', group:1, isRequest: true, label: 'registration.position', type: 'input' },
    // 商业登记文件
    { id: 'br_images', group:1, isRequest: true, label: 'registration.br_images', type: 'upload', desc: 'registration.br-file-desc', fileTitle: 'registration.br_file_title' }
];

const corporateForm = [
    // 公司名称
    { id: 'organisation_name', group:1, isRequest: true, label: 'registration.organisation_name', type: 'input' },
    // 职位
    { id: 'position', group:1, isRequest: true, label: 'registration.position', type: 'input' },
    // 邮寄地址
    { id: 'mailing_address', group:1, isRequest: true, label: 'registration.mailing_address', type: 'mailing-input' }
];

const patronForm = [
    // 公司名称
    { id: 'organisation_name', group:1, isRequest: true, label: 'registration.organisation_name', type: 'input' },
    // 职位
    { id: 'position', group:1, isRequest: true, label: 'registration.position', type: 'input' }
];

const getForm = (type) => {

    const form = {
        "fans": fansForm,
        "individual-fellows": [],
        "association-fellows": associationForm,
        "corporate-fellows": corporateForm,
        "patron": patronForm
    };

    const year = dayjs().get('year');

    return [
        // 称谓
        { id: 'title', group:1, isRequest: true, label: 'registration.title', type: 'select', options: titleOptions },
        // 姓氏
        { id: 'last_name', group:1, isRequest: true, label: 'registration.last_name', type: 'input' },
        // 名字
        { id: 'first_name', group:1, isRequest: true, label: 'registration.first_name', type: 'input' },
        // 昵称
        { id: 'preferred_name', group:1, isRequest: true, label: 'registration.preferred_name', type: 'input' },
        // 中文名
        { id: 'chinese_name', group:1, isRequest: false, label: 'registration.chinese_name', type: 'input' },
        // 出生日期
        { id: 'dob', group:1, isRequest: false, label: 'registration.dob', type: 'date', format: 'DD/MM', views: ['day', 'month'], min: dayjs(`${year}-01-01`), max: dayjs(`${year}-12-31`) },
        // 电话
        { id: 'contact_number', group:1, isRequest: false, label: 'registration.contact_number', type: 'tel', options: telOptions },
        ...form[type],
        // 了解来源
        { id: 'aware_hkdc_channel', isRequest: true, group:1, label: 'registration.aware_hkdc_channel', type: 'from-select' },
        // 从HKDC的设计活动中了解
        { id: 'aware_hkdc_channel_event', showType: 'hkdc-event', group:1, label: 'registration.provide-info', type: 'option-input' },
        // 从其他的设计活动中了解
        { id: 'aware_hkdc_channel_other', showType: 'other', group:1, label: 'registration.provide-info', type: 'option-input' },
        // 语言偏好
        { id: 'preference_language', group:1, isRequest: true, label: 'registration.preference_language', type: 'language', desc: 'registration.language-desc' },
        // 推荐码
        { id: 'referral_code', group:1, isRequest: false, label: 'registration.referral_code', type: 'number-input', desc: 'registration.referral-desc' },
        // 优惠码
        { id: 'promo_code', group:1, isRequest: false, label: 'registration.promo_code', type: 'number-input', desc: 'registration.promo-desc' },
        // 条款及政策 check
        { id: 'consent_join_member', isRequest: false, group:1, label: 'registration.consent_join_member', type: 'check' },
        // 条款及政策 check
        { id: 'consent_hkdc_tnc', isRequest: true, group:2, label: 'registration.consent_hkdc_tnc', type: 'check' },
        // 条款及政策 check
        { id: 'consent_transfer_data', isRequest: false, group:2, label: 'registration.consent_transfer_data', type: 'check' }
    ];
};

const getEditProfileForm = () => {

    return [
        // 称谓
        { id: 'salutation', isRequest: true, label: 'registration.title', type: 'select', options: titleOptions },
        // 姓氏
        { id: 'last_name', isRequest: true, label: 'registration.last_name', type: 'input' },
        // 名字
        { id: 'first_name', isRequest: true, label: 'registration.first_name', type: 'input' },
        // 昵称
        { id: 'preferred_name', isRequest: true, label: 'registration.preferred_name', type: 'input' },
        // 中文名
        { id: 'chinese_name', isRequest: false, label: 'registration.chinese_name', type: 'input' },
        // 出生日期
        { id: 'dob', isRequest: false, label: 'registration.dob', type: 'date', format: 'DD/MM', views: ['day', 'month'], min: dayjs(`${dayjs().get('year')}-01-01`), max: dayjs(`${dayjs().get('year')}-12-31`) },
        // 电话
        { id: 'contact_number', isRequest: false, label: 'registration.contact_number', type: 'tel', options: telOptions },
        // Email
        { id: 'email', isRequest: false, label: 'registration.user-email', type: 'email' },
        // 语言偏好
        { id: 'preference_language', isRequest: true, label: 'registration.preference_language', type: 'language', desc: 'registration.language-desc' }
    ];
};

const profileRecord = {
    salutation: '',
    last_name: '',
    first_name: '',
    preferred_name: '',
    chinese_name: '',
    mailing_address: '',
    preference_language: 'en',
    birth_day: '',
    birth_month: ''
};

const getLanguage = (value) => {
    let language = 'en';
    if (!!value && value !== 'en') {
      language = value === 'zh-HK' ? 'tc' : 'sc';
    }
    return language;
};

function getPaymentPreferenceList() {
    return [
      { value: 'back-in', label: 'Back-in', data: 'back-in' },
      { value: 'cheque', label: 'Cheque', data: 'cheque' }
    ];
}

export {
    telOptions,
    getForm,
    getEditProfileForm,
    profileRecord,
    getLanguage,
    getPaymentPreferenceList
};